<template>
  <v-layout
    row
    justify-center
  >
    <!-- <v-text-field
      dark
      v-model="username"
      :label="$t('common.username')"
      name="login"
      prepend-icon="mdi-account"
      type="text"
      v-on:keyup="handleEnter"
    /> -->
    <vuetify-google-autocomplete
      ref="address2"
      :id="id"
      :addressComponents="addressComponents"
      append-icon="mdi-map-search-outline"
      classname="form-control"
      :placeholder="$t('common.addressToSearch')"
      v-on:placechanged="getAddressData"
      country="es"
      solo
      enable-geolocation
      class="searchAddress"
    />
    <!-- <v-flex v-if="address">

      {{address}}
    </v-flex> -->
  </v-layout>
</template>
<script>
import axios from 'axios'
export default {
  name: 'AddressFind',
  components: {
  },
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: false
    },
    onUpdateAddress: {
      type: Function,
      required: true
    },
    addressComponents: {
      type: Object,
      required: false,
      default: () => ({
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        postal_code: 'short_name',
        point_of_interest: 'long_name',
        premise: 'long_name',
        neighborhood: 'long_name'
      }),
    }
  },
  data () {
    return {
      candidates: null,
      address: null,
      selectedPlace: null,
      address2:''
    }
  },
  computed: {
    andleEnter (e) {
      if (e.keyCode === 13) this.handleLogin()
    },
    enterpriseColor () {
      return this.$store.state.app.enterpriseColor
    },
    FontSizeContent () {
      return this.$store.state.app.FontSizeContent
    },
    locale () {
      return i18n.locale
    },
    isText () {
      return (!this.type || this.type === 'text')
    },
    isRichText () {
      return this.type === 'richText'
    },
    isTextArea () {
      return this.type === 'textArea'
    }
  },
  watch: {
  },
  mounted () {
    // this.$refs.address2.focus()
  },
  methods: {
    getAddressData: function (addressData, placeResultData, id) {
      this.address2 = addressData
      if (addressData && placeResultData) {
        this.address = {
          lat: addressData.latitude,
          lon: addressData.longitude,
          address: placeResultData.formatted_address
        }
        this.onUpdateAddress(this.address)
      }
    },
    handleChangePlace (item) {
      this.candidates = null
      this.selectedPlace = item


    },
  }
}
</script>
<style>
  .searchAddress {
    padding: 0 10px;
  }
  .searchAddress .v-input__slot {
    background-color: #EAEAEA !important;
    box-shadow: none !important;
    border: 1px solid rgb(194, 192, 192);
  }
</style>